import { ErrorId, ExtendedErrorId, ExtendedFieldId, FieldContent, FieldId, logger, overrideValidator, setCustomValidator, Validator } from '@sheerid/jslib';


const VALID_EMAIL_REGEXP = /(^\s*?[A-Za-z0-9!#$%&''*+\/=?^_`{|}~-]+(\.[A-Za-z0-9!#$%&''*+\/=?^_`{|}~-]+)*@([A-Za-z0-9!#$%&''*+\/=?^_`{|}~-]+(\.[A-Za-z0-9!#$%&''*+\/=?^_`{|}~-]+)+|\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])\s*?$)/;

export const addGoogleFiEmailValidator = () => {
    const googleFiEmailFieldId: ExtendedFieldId = 'googleEmail';

    const getGoogleFiEmailValidationError: Validator = (value: FieldContent): ExtendedErrorId | undefined => {
        const invalidError: ErrorId = 'invalidEmail';

        if (value === undefined || !VALID_EMAIL_REGEXP.test(value as string)) {
            return invalidError;
        }
        return;
    };
    setCustomValidator(googleFiEmailFieldId, getGoogleFiEmailValidationError);
};

export const addMemberIdValidator = () => {
    const memberIdFieldId: FieldId = 'memberId';

    const getMemberIdError: Validator = (value: FieldContent): ExtendedErrorId | undefined => {
        const invalidError: ErrorId = 'invalidMemberId';

        if (!(value as string).length) {
            return invalidError;
        }
        return;
    };

    overrideValidator(memberIdFieldId, getMemberIdError);
};

export const overrideStateDepartmentEmailValidator = () => {
    const stateDepartmentEmailFieldId: FieldId = 'email';

    const getStateDepartmentEmailValidationError: Validator = (value: FieldContent): ErrorId | undefined => {
        const invalidError: ErrorId = 'invalidEmail';

        if (
            value === undefined ||
            !VALID_EMAIL_REGEXP.test(value as string) ||
            (!(value as string).includes('state.gov') &&
            !(value as string).includes('google.com') &&
            !(value as string).includes('sheerid.com') &&
            !(value as string).includes('.mil'))
        ) {
            return invalidError;
        }
        return;
    };
    overrideValidator(stateDepartmentEmailFieldId, getStateDepartmentEmailValidationError);
};
